import EventChange from '@classes/GEI/EventChange';
import { Box, Typography } from '@mui/material';
import Utils from '@utils/index';
import React from 'react';
import styled from 'styled-components';

const Contaienr = styled(Box)`
  .MuiTypography-root {
    line-height: 1.60 !important;
  }
`

type EventContentHistoryItemProps = {
  history: EventChange;
  index?: number;
  timezone?: string;
}

const EventContentHistoryItem: React.FC<EventContentHistoryItemProps> = (props) => {
  const { history, index, timezone } = props;

  return (
    <Contaienr data-cy={`gei-event-content-history-${index}`} display="grid" gap="1rem" gridTemplateColumns="min-content max-content max-content" alignItems="center" paddingRight="0.5rem">
      {history.getIconElement()}
      <Typography variant="body2">{`${Utils.Date.format(new Date(history.ts), 'MMM Do, YYYY hh:mm:ss A', timezone)}`}</Typography>
      {history.getTextElement()}
    </Contaienr>
  )
}

export default EventContentHistoryItem;
